import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LoginIcon from '@mui/icons-material/Login';
import { CONFIG } from 'constants/constants';
import { BUTTON_BORDER_RADIUS } from 'constants/borderRadius';

/**
 * @typedef {object} SignedOutMessageProps
 * @property {string} [message='You have been signed out successfully.'] - Message to display
 */

/**
 * Signed out confirmation message.
 * Displayed after successful sign-out from all sessions (completeSignOut).
 *
 * @param {SignedOutMessageProps} props - Component props
 * @returns {React.ReactElement}
 */
const SignedOutMessage = ({ message = 'You have been signed out successfully.' }) => {
    /**
     * Redirects to the default application URL to sign in again
     */
    const handleSignIn = () => {
        window.location.href = CONFIG.DEFAULT_APP_URL;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                py: 3,
            }}
        >
            <CheckCircleOutlineIcon
                color="success"
                sx={{ fontSize: 64, mb: 2 }}
            />

            <Typography variant="h6" gutterBottom>
                Signed Out
            </Typography>

            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mb: 3 }}
            >
                {message}
            </Typography>

            <Button
                id="signout-signin-btn"
                variant="contained"
                color="primary"
                size="large"
                onClick={handleSignIn}
                startIcon={<LoginIcon />}
                sx={{ borderRadius: BUTTON_BORDER_RADIUS }}
            >
                Sign In
            </Button>
        </Box>
    );
};

SignedOutMessage.propTypes = {
    message: PropTypes.string,
};

export default SignedOutMessage;
